import {
  RESET_FILTER_BY_ID,
  TOGGLE_UPLOADED_BY,
  TOGGLE_ALBUM_ID,
} from './albumFolderPhotosFilterActions';

export const initialState = {
  albumFolderId: '',
  uploaderIds: [],
  albumIds: [],
};

const albumFolderPhotosFilterReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TOGGLE_UPLOADED_BY:
      return {
        ...state,
        uploaderIds: state.uploaderIds.includes(action.uploaderId)
          ? state.uploaderIds.filter(
              uploaderId => uploaderId !== action.uploaderId,
            )
          : [...state.uploaderIds, action.uploaderId],
      };
    case TOGGLE_ALBUM_ID:
      return {
        ...state,
        albumIds: state.albumIds.includes(action.albumId)
          ? state.albumIds.filter(albumId => albumId !== action.albumId)
          : [...state.albumIds, action.albumId],
      };

    case RESET_FILTER_BY_ID: {
      return state.albumFolderId === action.albumFolderId
        ? state
        : { ...initialState, albumFolderId: action.albumFolderId };
    }

    default:
      return state;
  }
};

export default albumFolderPhotosFilterReducer;
